import { OptionsClass } from "@/domain/entities/MainApp";

export const isPlaneNogValid = (cargoType: string, nog: string): boolean => {
  if (cargoType !== "plane") return true;
  return !!nog?.trim();
};

export const toFlightDateTimeStr = (
  value: string | null | undefined
): string => {
  if (!value) return "";
  const m = String(value).match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})/);
  return m ? `${m[1]} ${m[2]}` : "";
};

export const buildShcOptions = (
  commodityOptions: any[],
  selectedCommodity: any
): OptionsClass[] => {
  const defaultOption = new OptionsClass({ name: "-", value: "" });

  if (selectedCommodity?.value) {
    const shcCode = selectedCommodity.shcCode || "";
    return [
      defaultOption,
      ...(shcCode
        ? [
            new OptionsClass({
              name: shcCode,
              value: shcCode
            })
          ]
        : [])
    ];
  }

  const shcCodes = (commodityOptions || [])
    .map((item: any) => item.shcCode)
    .filter((code: any) => typeof code === "string" && code.trim().length)
    .map((code: string) => code.trim());

  const uniqueShcOptions = [...new Set(shcCodes)].map(
    (shcCode: string) =>
      new OptionsClass({
        name: shcCode,
        value: shcCode
      })
  );

  return [defaultOption, ...uniqueShcOptions];
};
